<template>
    <table class="s-table-fee-type animation-opacity" border="0">
        <thead>
            <th>Honorario</th>
            <th>Fecha de Registro</th>
            <th>Acciones</th>
        </thead>
        <tbody>
            <tr
                v-for="(fee, index) in listFeeType"
                :key="index"
            >
                <td class="s-table-fee-type__border-line">{{fee.fee}}</td>
                <td class="s-table-fee-type__border-line">{{fee.date}}</td>
                <td>
                    <div class="d-flex justify-center">
                        <OBtnOptionToolTipComp
                            smsTooltip="Actualizar Honorario"
                            icon="mdi-lead-pencil"
                            style="margin:2px"
                            @click="$emit('clickupdate', fee)"
                        />
                        <OBtnOptionToolTipComp
                            smsTooltip="Eliminar Honorario"
                            icon="mdi-trash-can"
                            style="margin:2px"
                            @click="$emit('clickdelete', fee)"
                        />
                    </div>
                </td>
            </tr>
            <tr v-if="listFeeType.length==0" class="text-center">
                <td colspan="3">SIN DATOS</td>
            </tr>
        </tbody>
    </table>
</template>
<script>
import { OBtnOptionToolTipComp } from '../organisms'
export default {
    props: {
        listFeeType: Array
    },
    components: {
        OBtnOptionToolTipComp
    }
}
</script>